module.exports = __webpack_public_path__ + "img/galleon-sailing-by-sea.67b00c81.jpg";